export default "__VITE_ASSET__mCGew0Wj__"